import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import Wcs1 from "./Wcs1";
import axios from "axios";
import { Link } from "react-router-dom";
import Table from "./Table";
import './MajorProduct.scoped.scss';
import {
  MDBCard,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
  MDBCardImage,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";

function AdminHome1() {

  return (
    <>
    <div className="twonhub">
      <div className="row">
        <div className="col-md-3"></div>
        <div
          className="col-md-9"
         
        >
          <div
            className="container"
            style={{
              border: "1px solid #24496a",
              borderRadius: "10px",
              marginBottom: "10px",
              boxShadow:" rgb(0 0 0 / 16%) 0px 1px 4px",
              border:" 1px solid rgb(36 73 106 / 21%)",
            }}
          >
            <div class="container">
              <div class="loginform" style={{ textAlign: "center" }}>
                <h1
                  style={{
                    color: "#24496a",
                    fontFamily: "Yantramanav,sans-serif",
                  }}
                >
                  <b>Home</b>
                </h1>
              </div>
              
            </div>
            <br />
            <div className="home">
              <Wcs1 />
            </div>
            <br/>
            <Table/>
            <p style={{float:"right",display:"flex"}}>
              <Link to={`/applieddetails`}>
              <button type="button" class="btn btn-outline-primary mt-2 pt-2">View all</button>
              </Link>
            </p>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default AdminHome1;
